export const DEFAULT_AGENT_ICON = 'mdi-robot-outline'

export function resolveAgentIcon(icon?: string | null): string {
  if (typeof icon !== 'string') {
    return DEFAULT_AGENT_ICON
  }

  const trimmed = icon.trim()
  return trimmed.length > 0 ? trimmed : DEFAULT_AGENT_ICON
}
